import { render } from "./ReportPoll.vue?vue&type=template&id=805c926a&scoped=true"
import script from "./ReportPoll.vue?vue&type=script&lang=js"
export * from "./ReportPoll.vue?vue&type=script&lang=js"

import "./ReportPoll.vue?vue&type=style&index=0&id=805c926a&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805c926a"]])

export default __exports__